import { useContext } from "react";
import { Menu, Theme, SxProps, PopoverOrigin, PopoverPosition } from "@mui/material";
import { DropdownContext } from "./index";

/**
 * @typedef {Object} CustomDropdownProps
 * @property {React.ReactNode} children
 * @property {SxProps<Theme>} sx
 * @property {PopoverOrigin} transformOrigin
 * @property {PopoverOrigin} anchorOrigin
 * @property {PopoverPosition} anchorPosition
 * @property {((event: {}, reason: "backdropClick" | "escapeKeyDown") => void) | undefined} onClose
 */

/**
 * @param {CustomDropdownProps} param0
 * @returns {JSX.Element} Dropdown component
 */

const DropdownMenu = ({ children, ...menuProps }) => {
  const { open, anchorEl, handleClose } = useContext(DropdownContext);

  return (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={open}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
      {...menuProps}
      onClose={(e) => {
        handleClose(e);
        menuProps?.onClose?.(e);
      }}
    >
      {children}
    </Menu>
  );
};

export default DropdownMenu;
